'use strict';

var makeObject = require('./make-object');

module.exports = function (oldKey, key) {
  return function (query) {
    var value = query[oldKey];
    return value ? makeObject(key, value, String) : {};
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/last-search-cookie/rename-field.js
 ** module id = 457
 ** module chunks = 0
 **/